import { useState } from "react";
import { Fragment } from "react";
import { useEffect } from "react";

import { Grid, lighten, Tooltip, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { v4 as uuid } from "uuid";

import { millisecondsStringToSecondsTimeString } from "../../utils/helpers";
import OmniAssessmentValueTextFab from "../ui/omniAssessmentValueTextFab";

const Counter = props => {
  const { isActive, resetTimer, setLocalAnswer, setResetTimer, localAnswer } = props;

  const [time, setTime] = useState(localAnswer ? parseInt(localAnswer) : 0);
  useEffect(() => {
    let counter = null;
    if (isActive) {
      counter = setInterval(() => {
        setTime(prevTime => prevTime + 10);
      }, 10);
    } else {
      setLocalAnswer(time);
      clearInterval(counter);
    }
    return () => clearInterval(counter);
  }, [isActive, setLocalAnswer, time]);

  useEffect(() => {
    if (resetTimer) {
      setTime(0);
      setResetTimer(false);
    }
  }, [resetTimer, setResetTimer, setTime]);

  return (
    <Grid
      item
      sx={[
        millisecondsStringToSecondsTimeString(time).toString().includes(".11") && {
          paddingRight: "4px",
        },
      ]}
    >
      <Typography variant="h3" sx={{ textAlign: "center", fontVariant: "tabular-nums" }}>
        {millisecondsStringToSecondsTimeString(time)}
      </Typography>
    </Grid>
  );
};

const QuestionStopwatchDisplay = props => {
  const { question, onAnswerSelected } = props;

  const [isActive, setIsActive] = useState(false);
  const [resetTimer, setResetTimer] = useState(false);

  const theme = useTheme();

  //just manages state
  const [localAnswer, setLocalAnswer] = useState(question.answerValue ? question.answerValue : "");
  useEffect(() => {
    if (question.answerValue && question.answerValue[0]) {
      setLocalAnswer(question.answerValue[0]);
    }
  }, [question, setLocalAnswer]);

  useEffect(() => {
    onAnswerSelected([localAnswer]);
  }, [localAnswer, onAnswerSelected]);

  const handleStartStop = () => {
    setIsActive(prevVal => !prevVal);
  };

  const handleReset = () => {
    setResetTimer(true);
  };

  return (
    <Grid container item xs={11} justifyContent={"space-around"} spacing={2}>
      <Grid item justifyItems={"center"}>
        <Counter
          isActive={isActive}
          resetTimer={resetTimer}
          setLocalAnswer={setLocalAnswer}
          setResetTimer={setResetTimer}
          localAnswer={localAnswer}
        />
      </Grid>
      <Grid
        id={`questionGrid1`}
        key={uuid()}
        container
        item
        xs={11}
        justifyContent="center"
        spacing={2}
      >
        <Tooltip title={question.answerOptions[0].helpText || ""} placement="left">
          <Fragment>
            <OmniAssessmentValueTextFab
              key={`answerOption${uuid()}`}
              color="primary"
              size="large"
              variant={"contained"}
              onClick={handleStartStop}
              sx={{
                width: "100%",
                boxShadow: `inset 0px 0px 1px 1px ${lighten(theme.palette.primary.dark, 0.15)}`,
                "&:hover": { color: theme.palette.primary.contrastText },
              }}
            >
              <Grid
                container
                justifyContent="center"
                direction="row"
                sx={{ width: "100%", alignItems: "center" }}
              >
                <Grid item justifySelf="center" xs>
                  <Typography key={uuid()} variant="button">
                    {isActive ? "Stop" : "Start"}
                  </Typography>
                </Grid>
              </Grid>
            </OmniAssessmentValueTextFab>
          </Fragment>
        </Tooltip>
      </Grid>
      <Grid
        id={`questionGrid1`}
        key={uuid()}
        container
        item
        xs={11}
        justifyContent="center"
        spacing={2}
      >
        <Tooltip title={question.answerOptions[0].helpText || ""} placement="left">
          <Fragment>
            <OmniAssessmentValueTextFab
              key={`answerOption${uuid()}`}
              color="primary"
              size="large"
              variant={"outlined"}
              onClick={handleReset}
              disabled={isActive}
              // onClick={e => {
              //   e.stopPropagation();
              //   setLocalAnswer([answerOption.value]);
              //   onAnswerSelected([answerOption.value]);
              //   startNextTimer(defaultDelay);
              // }}
              sx={{ width: "100%", "&:hover": { color: theme.palette.primary.contrastText } }}
            >
              <Grid
                container
                justifyContent="center"
                direction="row"
                sx={{ width: "100%", alignItems: "center" }}
              >
                <Grid item justifySelf="center" xs>
                  <Typography key={uuid()} variant="button">
                    Reset
                  </Typography>
                </Grid>
              </Grid>
            </OmniAssessmentValueTextFab>
          </Fragment>
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default QuestionStopwatchDisplay;
